/**
 * NOTE: Native-only
 */
export function handleHardwareBackButtonPress(_callback: () => void) {
  return {
    removeListener() {},
  };
}
